import * as types from './actionTypes';

export function setCords(cordsData) {
  return {
    type: types.SET_CORDS,
    ...cordsData,
  };
}

export function resetCords() {
  return {
    type: types.RESET_CORDS,
  };
}

